<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
}
.main {
  width: 80%;
  /* background-color: pink; */
}

.container {
  display: flex;
  height: calc(100% - 80px);
}
.input-side {
  margin: 10px 20px;
  min-width: 200px;
  max-width: 300px;
  padding: 0 10px;
}
</style>
